import React from 'react';
import { Wrapper } from "./style.js";
import { Icon } from "semantic-ui-react";
import UnitList from '../UnitList';

const filterByStep = (debriefs, index, complete) => 
    debriefs.filter(d => Array.isArray(d.completed_stages) && d.completed_stages[index] === complete).map(d => d.meeting.shift);
    
const PartialList = (props) => {
    const { groups, step } = props;

    return (<Wrapper>
        <h4 className="partial-heading"><i className="partial icon"/>Partially Complete Work Settings</h4>
        <ul>
            {groups.map( (g,i) => (
            <li key={i} className="partial-group">
                <h5>{g[0].unit}</h5>
                <div className="cols">
                    <UnitList completed debriefs={filterByStep(g, step, true)} completed/>
                    <UnitList completed debriefs={filterByStep(g, step, false)} completed={false}/>
                </div>
            </li>
            ))}
        </ul>
    </Wrapper>)
}

export default PartialList;
  


// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/Debriefs/components/DebriefDashboard/components/PartialList/index.jsx